import { Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Product from '@/pages/Product';
import Features from '@/pages/Features';
import Pricing from '@/pages/Pricing';
import GetStarted from '@/pages/GetStarted';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import About from '@/pages/About';
import Careers from '@/pages/Careers';
import Solutions from '@/pages/Solutions';
import Industry from '@/pages/Industry';
import TeamSolution from '@/pages/TeamSolution';
import Referral from '@/pages/Referral';
import WhyChoose from '@/pages/WhyChoose';

export default function App() {
  return (
    <Routes>
      <Route path='/' element={<Layout />}>
        <Route index element={<Home />} />
        <Route path='product' element={<Product />} />
        <Route path='features' element={<Features />} />
        <Route path='pricing' element={<Pricing />} />
        <Route path='book-a-demo' element={<GetStarted />} />
        <Route path='about' element={<About />} />
        <Route path='careers' element={<Careers />} />
        <Route path='solutions' element={<Solutions />} />
        <Route path='solutions/:slug' element={<TeamSolution />} />
        <Route path='industry/:slug' element={<Industry />} />
        <Route path='why-zuri' element={<WhyChoose />} />
        <Route path='referral' element={<Referral />} />
        <Route path='terms' element={<Terms />} />
        <Route path='privacy' element={<Privacy />} />
      </Route>
    </Routes>
  );
}
